export default function isBlank(str: string | null | undefined) {
  return !str || /^\s*$/.test(str);
}
